<template>
  <div class="row delivery-block">
    <!-- <h2 class="bold text-center">
          {{ $t('deliveryPage.deliveryHeader') }}
        </h2>
        <div v-html="$t('deliveryPage.first')"></div> -->
    <!-- <div class="col-md-12"> -->
    <div class="h2 text-center">{{ $t('deliveryBlock.first.title') }}</div>
    <div class="h5 text-center">
      {{ $t('deliveryBlock.first.subTitle') }}
    </div>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="send-money"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.first.list1.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text primary-text">
              <p>
                {{ $t('deliveryBlock.first.list1.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="pos"
              class="seasidetms_icon_list_icon seasidetms-icon-basket-3"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.first.list2.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('deliveryBlock.first.list2.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="online-payment"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.first.list3.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text primary-text">
              <p>
                {{ $t('deliveryBlock.first.list3.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="cash"
              class="seasidetms_icon_list_icon seasidetms-icon-basket-3"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.first.list4.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('deliveryBlock.first.list4.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="h2 text-center col-md-12 mt-20">
      {{ $t('deliveryBlock.second.title') }}
    </div>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="post-office"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.second.list1.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text secondary-text">
              <p v-html="$t('deliveryBlock.second.list1.text')"></p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="credit-card"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.second.list2.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text secondary-text">
              <p>
                {{ $t('deliveryBlock.second.list2.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="credit-card"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.second.list3.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('deliveryBlock.second.list3.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="credit-card"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('deliveryBlock.second.list4.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('deliveryBlock.second.list4.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'Delivery',
}
</script>

<style>
.primary-text {
  min-height: 140px !important;
}
.seasidetms_icon_list_item {
  padding-bottom: 15px !important;
}
.secondary-text {
  min-height: 190px !important;
}
.delivery-block {
  clear: both;
  margin-top: 30px;
}
</style>
